import { useGlobalStore } from "../context/UserContext/userContext";
import { isCreReportBlocked, isInMedMicDesktop } from "./publicUsersAccess";

/** "All Public Users": no report window (see publicUsersAccess.js). */
export function useCreReportBlocked() {
  const authSource = useGlobalStore((s) => s.authSource);
  const creUser = useGlobalStore((s) => s.creUser);
  const creSelectedOrganisationId = useGlobalStore((s) => s.creSelectedOrganisationId);
  return isCreReportBlocked({
    authSource,
    creUser,
    creSelectedOrganisationId,
    inMedMicDesktop: isInMedMicDesktop(),
  });
}
